var installedModules = {};
var moduleToHandlerMapping = {
	9361: {
		getter: function() { return __webpack_require__.e(6593).then(function() { return function() { return __webpack_require__(2155); }; }); },
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": false,
			  "strictVersion": false,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "react",
	},
	7570: {
		getter: function() { return __webpack_require__.e(6593).then(function() { return function() { return __webpack_require__(1378); }; }); },
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": false,
			  "strictVersion": false,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "react-dom/client",
	},
	2285: {
		getter: function() { return Promise.all([__webpack_require__.e(6593), __webpack_require__.e(8884)]).then(function() { return function() { return __webpack_require__(316); }; }); },
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": false,
			  "strictVersion": false,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "react-dom",
	},
	9722: {
		getter: function() { return __webpack_require__.e(6593).then(function() { return function() { return __webpack_require__(5723); }; }); },
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": false,
			  "strictVersion": false,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "react/jsx-runtime",
	},
	3195: {
		getter: function() { return Promise.all([__webpack_require__.e(2126), __webpack_require__.e(2455), __webpack_require__.e(661), __webpack_require__.e(2285)]).then(function() { return function() { return __webpack_require__(661); }; }); },
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": false,
			  "strictVersion": false,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "next/router",
	},
	2712: {
		getter: function() { return Promise.all([__webpack_require__.e(6611), __webpack_require__.e(2512)]).then(function() { return function() { return __webpack_require__(2512); }; }); },
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "",
			  "strictVersion": false,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "@rc-d2c/context-manager",
	},
	8997: {
		getter: function() { return __webpack_require__.e(8585).then(function() { return function() { return __webpack_require__(966); }; }); },
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "13.5.7",
			  "strictVersion": false,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "next/head",
	},
	4341: {
		getter: function() { return __webpack_require__.e(6456).then(function() { return function() { return __webpack_require__(6456); }; }); },
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "13.5.7",
			  "strictVersion": false,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "next/link",
	},
	2498: {
		getter: function() { return __webpack_require__.e(8585).then(function() { return function() { return __webpack_require__(966); }; }); },
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "^12 || ^13 || ^14",
			  "strictVersion": false,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "next/head",
	},
	8086: {
		getter: function() { return Promise.all([__webpack_require__.e(2126), __webpack_require__.e(6456), __webpack_require__.e(2877)]).then(function() { return function() { return __webpack_require__(6456); }; }); },
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "^12 || ^13 || ^14",
			  "strictVersion": false,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "next/link",
	},
	6439: {
		getter: function() { return Promise.all([__webpack_require__.e(2455), __webpack_require__.e(2285), __webpack_require__.e(3122)]).then(function() { return function() { return __webpack_require__(3327); }; }); },
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "^12 || ^13 || ^14",
			  "strictVersion": false,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "next/script",
	},
	5332: {
		getter: function() { return Promise.all([__webpack_require__.e(9915), __webpack_require__.e(2285)]).then(function() { return function() { return __webpack_require__(9915); }; }); },
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "^12 || ^13 || ^14",
			  "strictVersion": false,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "next/image",
	},
	2340: {
		getter: function() { return __webpack_require__.e(7720).then(function() { return function() { return __webpack_require__(5339); }; }); },
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "^12 || ^13 || ^14",
			  "strictVersion": false,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "next/dynamic",
	},
	9607: {
		getter: function() { return __webpack_require__.e(3197).then(function() { return function() { return __webpack_require__(5578); }; }); },
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "^5.1.1",
			  "strictVersion": false,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "styled-jsx",
	},
	5630: {
		getter: function() { return __webpack_require__.e(2736).then(function() { return function() { return __webpack_require__(355); }; }); },
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "^5.1.1",
			  "strictVersion": false,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "styled-jsx/style",
	},
	5025: {
		getter: function() { return __webpack_require__.e(3327).then(function() { return function() { return __webpack_require__(3327); }; }); },
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "13.5.7",
			  "strictVersion": false,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "next/script",
	}
};
var initialConsumes = [9361,7570,2285,9722,3195,2712,8997,4341,5025];
__webpack_require__.federation.installInitialConsumes = function() { return __webpack_require__.federation.bundlerRuntime.installInitialConsumes({
	initialConsumes: initialConsumes,
	installedModules:installedModules,
	moduleToHandlerMapping:moduleToHandlerMapping,
	webpackRequire: __webpack_require__
}); }
var chunkMapping = {
	"244": [
		5025
	],
	"636": [
		9722,
		3195,
		2712,
		8997,
		4341
	],
	"2285": [
		2285
	],
	"5120": [
		2498,
		3195,
		8086,
		6439,
		5332,
		2340,
		9607,
		5630,
		9722
	],
	"8792": [
		9361,
		7570,
		2285
	],
	"8884": [
		9361
	]
};
__webpack_require__.f.consumes = function(chunkId, promises) {
	__webpack_require__.federation.bundlerRuntime.consumes({
	chunkMapping: chunkMapping,
	installedModules: installedModules,
	chunkId: chunkId,
	moduleToHandlerMapping: moduleToHandlerMapping,
	promises: promises,
	webpackRequire:__webpack_require__
	});
}